import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { store } from "./store";
import { Provider } from "react-redux";
import { ToastContainer } from "components/toast";
import { DarkModeProvider } from "context/DarkModeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <DarkModeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </DarkModeProvider>
    <ToastContainer />
  </Provider>
);
